import styled from "styled-components";
import { media } from "../../../../../components/common/media";

const ActionContentContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 50px auto 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${media.desktop`
    margin: 25px auto 0;
  `}
  & > div {
    width: 45%;
    position: relative;
    ${media.desktop`
      width: 100%;
      margin-bottom: 25px;
    `}
    img {
      width: 100%;
    }
    .filter {
      background: rgba(0, 0, 0, 0.2);
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
    .text {
      position: absolute;
      bottom: 30px;
      width: 85%;
      left: 30px;
      h3 {
        color: #fff;
        font-size: 32px;
        ${media.desktop`
          font-size: 24px;
        `}
      }
      p {
        color: #fff;
        font-size: 16px;
        line-height: 150%;
        ${media.desktop`
          font-size: 12px;
        `}
      }
      button {
        width: 150px;
        background: ${(props) => props.theme.colors.primary.main};
        color: #fff;
        &:hover {
          box-shadow: 0px 3px 1px -2px rgb(255 255 255 / 20%),
            0px 2px 2px 0px rgb(255 255 255 / 14%), 0px 1px 5px 0px rgb(255 255 255 / 12%);
          background: ${(props) => props.theme.colors.primary.main}
        }
      }
    }
  }
`;

export default ActionContentContainer;
